import React, { useEffect, useState } from "react";
import Navbar from "../components/Navbar";
import TeamSection from "../components/TeamSection"; // Import the TeamSection component
import "../styles/About_us.css";
import aboutImage from "../assets/about.webp";


const skillsData = [
  { name: "Cybersecurity", percent: 90 },
  { name: "Custom Development", percent: 94 },
  { name: "AI & Automation", percent: 88 },
  { name: "Product Development", percent: 86 },
];

const AboutUs = () => {
  const [fadeIn, setFadeIn] = useState(false);
  const [scrolled, setScrolled] = useState(0);

  useEffect(() => {
    const fadeTimeout = setTimeout(() => setFadeIn(true), 300);

    const handleScroll = () => {
      const scrollPercent = Math.min(window.scrollY / 500, 1);
      setScrolled(scrollPercent);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      clearTimeout(fadeTimeout);
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  return (
    <>
      <Navbar />
      <main className={`about-main ${fadeIn ? "visible" : ""}`} style={{ marginTop: "100px" }}>
        {/* Darkening Overlay */}
        <div className="scroll-darkening-overlay" style={{ opacity: scrolled * 0.7 }}></div>

        {/* HERO SECTION */}
        <section className="hero-section1">
          <video
            autoPlay
            muted
            loop
            playsInline
            className="background-video"
            controlsList="nodownload"
            onContextMenu={(e) => e.preventDefault()}
          >
            <source
              src="https://videos.pexels.com/video-files/6037155/6037155-hd_2732_1440_30fps.mp4"
              type="video/mp4"
            />
            Your browser does not support the video tag.
          </video>
          <div className="overlay"></div>
          <div className="hero-content1">
            <h1>Who are We?</h1>
            <h2>Empowering a Safer Digital World through Innovation and Expertise</h2>
          </div>
        </section>

        {/* ABOUT SECTION */}
        <section className="about-section">
          <div className="container">
            <div className="content-wrapper">
              <div className="text-content">
                <h2 className="section-title">We Always Make The Best</h2>
                <p className="section-text">
                  The deep-tech advisory firm EncryptArx delivers advisory services for cybersecurity and SaaS security,
                  AI/ML-driven development, cloud security, and DevSecOps compliance to enhance security measures.
                </p>
                <p className="section-text">
                  Our expertise includes AI automation, API security, and secured architecture. We work with startups,
                  SaaS enterprises, and industries like tech, e-commerce, healthcare, and finance to protect them during digital evolution.
                </p>
              </div>
              <div className="image-content">
                <img src={aboutImage} alt="Person working on multiple monitors in a studio" />
              </div>
            </div>
          </div>
        </section>

        {/* TEAM SECTION */}
        <TeamSection />

        {/* SKILLS SECTION */}
        <section className="skills-section">
          <div className="container">
            <h2 className="section-title">Our Expertise</h2>
            <p className="section-subtitle">Empowering Businesses with Cutting-Edge Technology & Security</p>
            <div className="skills-grid">
              {skillsData.map((skill, index) => (
                <div className="skill-item" key={index}>
                  <div className="skill-header">
                    <span className="skill-name">{skill.name}</span>
                    <span className="skill-percentage">{skill.percent}%</span>
                  </div>
                  <div className="skill-progress">
                    <div className="progress-bar" style={{ width: `${skill.percent}%` }}></div>
                  </div>
                </div>
              ))}
            </div>
          </div>
        </section>

        {/* VISION & MISSION SECTION */}
        <section className="vision-mission-section">
          <div className="container">
            <div className="vision-mission-grid">
              <div className="vision-card">
                <h2>Vision</h2>
                <div className="vision-content">
                  <p>✓ Be a trusted digital security provider for businesses worldwide.</p>
                  <p>✓ Strengthen cybersecurity with AI-driven approaches.</p>
                  <p>✓ Focus on R&D for continuous technical advancements.</p>
                </div>
              </div>
              <div className="mission-card">
                <h2>Mission Statement</h2>
                <p>
                  Build a robust and agile IT services business by creating value for our customers, employees, and communities.
                </p>
                <p>
                  We provide high-value solutions with insight, transparency, and integrity at the core of our operations.
                </p>
              </div>
            </div>
          </div>
        </section>

        {/* VALUES SECTION */}
        <section className="values-section">
          <div className="container">
            <h2 className="section-title">VALUES</h2>
            <p className="values-subtitle">Our values define our Identity.</p>
            <div className="values-grid">
              <div className="value-card single-row">
                <div className="value-left">
                  <span className="value-icon">🤝</span>
                  <h3>Diligent and Commited</h3>
                </div>
                <div className="value-right">
                  <p>We continuously improve in every aspect-work, home, and community</p>
                </div>
              </div>
              <div className="value-card single-row">
                <div className="value-left">
                  <span className="value-icon">👥</span>
                  <h3>Collaboration</h3>
                </div>
                <div className="value-right">
                  <p>Working together ensures our customers' success, which is our success.</p>
                </div>
              </div>
              <div className="value-card single-row">
                <div className="value-left">
                  <span className="value-icon">💡</span>
                  <h3>Continuous Learning</h3>
                </div>
                <div className="value-right">
                  <p>We foster innovation by attracting top talent and evolving constantly.</p>
                </div>
              </div>
              <div className="value-card single-row">
                <div className="value-left">
                  <span className="value-icon">🎯</span>
                  <h3>Optimism</h3>
                </div>
                <div className="value-right">
                  <p>We believe effort and dedication yield positive outcomes.</p>
                </div>
              </div>
              <div className="value-card single-row">
                <div className="value-left">
                  <span className="value-icon">❤️</span>
                  <h3>Gratitude</h3>
                </div>
                <div className="value-right">
                  <p>We're grateful for the opportunity to support our community and grow together.</p>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* CTA SECTION */}
        <section className="cta-section">
          <div className="container">
            <h2 className="cta-title">Your Security is Our Priority</h2>
            <button className="primary-button glow">Get in Touch</button>
          </div>
        </section>
      </main>
    </>
  );
};

export default AboutUs;
